<template>
  <div class="location-options">
    <ul v-if="displayed_practices.length > 0">
      <li v-for="practice in displayed_practices" :key="practice.ID">
        <label :for="practice.post_name" @click="onSelectPractice(practice)" :class="{active: appointment.practice.ID === practice.ID}">
          <div class="content">
            <img :src="`/app/themes/leightons/images/${appointment.practice.ID === practice.ID ? 'house-pin-icon-purple.svg' : 'house-pin-icon.svg'}`" width="36"/>
            <h3>{{ practice.post_title }}</h3>
            <p>{{ practice.ad_address }}</p>
            <p class="meta" v-if="user_location_cord != null">{{ practice.distance }} miles away</p>
          </div>
          <div class="footer"
              :class="{'no-appointment': !practice.has_next_appointment }"
              v-html="practice.next_appointment_info">
          </div>
        </label>
      </li>
    </ul>
    <ul v-if="displayed_practices.length == 0">
      <p>No practices with availability in the next {{getXWeeksValue}} {{getXWeeksValue > 1 ? "weeks" : "week"}}.</p>
    </ul>
    <div class="show-more" v-if="(all_practices && all_practices.length > pageSize)">
      <p>Showing {{ getCurrentPaginationDisplayedItems }} of {{all_practices.length}}</p>
      <button class="button secondary-button" @click.prevent="onShowMorePractices" v-show="(pagination.current_page < pagination.total_page)">{{ getShowMoreText}}</button>
    </div>
  </div>
</template>

<script>

export default {

  created() {
    this.currentURL = location.host;
  },

  name: "BookingLocationList",
  emits: ["onShowMore", "onSelect"],
  props: [
    "appointment",
    "displayed_practices",
    "all_practices",
    "user_location_cord",
    "pagination"
  ],
  data () {
    return {
      currentURL: "",
    }
  },
  methods: {

    onSelectPractice(practice) {
      this.$emit("onSelect", practice);
    },

    onShowMorePractices() {
      this.$emit("onShowMore");
    },

  },

  mounted() {

  },

  computed: {
    getXWeeksValue() {
      if (this.appointment.bookingConfigs && this.appointment.bookingConfigs.practices_availability_x_weeks) {
        return parseInt(this.appointment.bookingConfigs.practices_availability_x_weeks);
      }
      return 4;
    },
    pageSize() {
      return this.pagination.items_per_page;
    },
    getCurrentPaginationDisplayedItems() {
      let nb = this.pagination.current_page * this.pageSize;
      if (nb > this.all_practices.length) {
        nb = this.all_practices.length;
      }
      return nb;
    },
    getShowMoreText() {
      const nb = this.getCurrentPaginationDisplayedItems;
      const item_to_load = Math.min(this.pageSize, this.all_practices.length - nb);
      return `Show ${item_to_load} more`;
    }
  }

};
</script>

<style lang="postcss" scoped>
section {

  .location-options {
    @apply px-[30px] xl:px-0;
  }

  ul {
    @apply mx-auto block sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-12 mt-[40px] sm:mt-[20px] border-t border-navy py-[45px] border-opacity-20;

    li {

      @apply mb-5 last:mb-0 sm:mb-0;

      label {
        @apply relative flex flex-col sm:min-h-[350px] sm:h-full transition-colors cursor-pointer bg-white border-2 border-aqua rounded-[15px] overflow-hidden;
        box-shadow: 0px 3px 15px rgba(0,0,0,0.16);

        &.active {
          @apply border-purple-darker bg-[#FFF0FB];

          .footer {
            @apply bg-[#FFE2F7];
          }
        }

        .content {
          @apply p-5 sm:p-10 sm:pr-20;

          img {
            @apply max-w-[27px] sm:max-w-none mb-[20px] sm:mb-4;
          }

          h3 {
            @apply text-body-xl;
          }

          p {
            @apply mb-[14px] last:mb-0;

            &.meta {
              @apply text-[#446481] text-[15px] leading-[20px];
            }
          }
        }

        .footer {
          @apply w-full bg-[#F2FCFC] py-8 px-5 sm:px-10 mt-auto;
          @apply font-avenir-medium;
        }

        .footer.no-appointment {
          @apply text-[#557490] h-[108px];
        }
      }
    }
  }

  .show-more {
    @apply mx-auto text-center pb-[40px];

    p {
      @apply mb-[10px] font-avenir-medium text-grey-darker;
    }

    button.btn {
      @apply w-full sm:w-auto;
    }
  }
}

@media (min-width:1300px) {
  section {

    ul {
      @apply w-[1300px];
    }

    .show-more {
      @apply w-[1300px];
    }
  }
}
</style>
